import script from "./CreateUpdateLayers.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateUpdateLayers.vue?vue&type=script&setup=true&lang=js"

import "./CreateUpdateLayers.vue?vue&type=style&index=0&id=00134479&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00134479"]])

export default __exports__